import * as React from 'react'

const useOutsideClick = (element: React.RefObject<any>, onClick: () => void) => {
  React.useEffect(() => {
    const onMouseEvent = (event: MouseEvent) => {
      if (element.current && !element.current.contains(event.target)) {
        onClick()
      }
    }

    document.addEventListener('mousedown', onMouseEvent)
    return () => document.removeEventListener('mousedown', onMouseEvent)
  }, [element])
}

export default useOutsideClick
